import { useState, useEffect, useRef } from 'react';

import { getBounding } from "utils/elementExt";

const useDropdownPosition = (initialDropdownIsOpen, buttonRef) => {
  const [dropdownIsOpen, setDropdownIsOpen] = useState(initialDropdownIsOpen);
  const dropdownVerticalPositionRef = useRef('bottom');
  const positionRef = useRef({});
  const topRef = useRef(null);
  const bottomRef = useRef(null);

  const calculateDropdownPosition = () => {
    if (!buttonRef.current) return;
    
    const buttonPosition = getBounding(buttonRef.current);
    const remainingSpaceBelow = window.innerHeight - buttonPosition.bottom;

    if (remainingSpaceBelow < window.innerHeight / 2) {
      dropdownVerticalPositionRef.current = 'top';
      topRef.current = window.innerHeight - buttonPosition.top;
      bottomRef.current = 'unset';
    } else {
      dropdownVerticalPositionRef.current = 'bottom';
      topRef.current = 'unset';
      bottomRef.current = buttonPosition.bottom;
    }

    positionRef.current = buttonPosition;
  };

  const showdropdown = () => {
    setDropdownIsOpen((prevState) => !prevState);
    calculateDropdownPosition();
  };

  useEffect(() => {
    if (!initialDropdownIsOpen) {
      setDropdownIsOpen(initialDropdownIsOpen);
    }
  }, [initialDropdownIsOpen]);

  return {
    dropdownIsOpen,
    dropdownVerticalPosition: dropdownVerticalPositionRef.current,
    position: positionRef.current,
    top: topRef.current,
    bottom: bottomRef.current,
    showdropdown,
    setDropdownIsOpen,
  };
};

export default useDropdownPosition;